import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import {
  CompletedWithErrorsSvg,
  IconAbortJob,
  IconCheckCircleIconGreenSvg,
  IconCrossCircleIconSvg,
  IconInProgressSvg,
  IconInQueueSvg,
} from "./icons";
import { ValidationStatusProps } from "../../types/Validation.type";

const DashboardJobstatusIcon: React.FC<ValidationStatusProps> = ({
  status = "",
}) => {
  if (status === "in_queue") {
    return (
      <Tooltip title="Inqueue" placement="top" arrow>
        <IconButton className="datagrid-action-btn p-0" color="inherit">
          <IconInQueueSvg />
        </IconButton>
      </Tooltip>
    );
  }

  if (status === "in_progress") {
    return (
      <Tooltip title="In Progress" placement="top" arrow>
        <IconButton className="datagrid-action-btn p-0" color="inherit">
          <IconInProgressSvg />
        </IconButton>
      </Tooltip>
    );
  }
  if (status === "aborted") {
    return (
      <Tooltip title="Aborted" placement="top" arrow>
        <IconButton className="datagrid-action-btn p-0" color="inherit">
          <IconAbortJob />
        </IconButton>
      </Tooltip>
    );
  }

  if (status === "completed") {
    return (
      <Tooltip title="Completed" placement="top" arrow>
        <IconButton className="datagrid-action-btn p-0" color="inherit">
          <IconCheckCircleIconGreenSvg />
        </IconButton>
      </Tooltip>
    );
  }

  if (status === "terminated") {
    return (
      <Tooltip title="Terminated" placement="top" arrow>
        <IconButton className="datagrid-action-btn p-0" color="inherit">
          <IconCrossCircleIconSvg />
        </IconButton>
      </Tooltip>
    );
  }

  if (status === "completed_with_errors") {
    return (
      <Tooltip title="Completed With Errors" placement="top" arrow>
        <IconButton className="datagrid-action-btn p-0" color="inherit">
          <CompletedWithErrorsSvg />
        </IconButton>
      </Tooltip>
    );
  }
  return (
    <Tooltip title="Failed" placement="top" arrow>
      <IconButton className="datagrid-action-btn p-0" color="inherit">
        <IconCrossCircleIconSvg />
      </IconButton>
    </Tooltip>
  );
};

export default DashboardJobstatusIcon;
